import React, { useEffect, useState } from 'react'
import { fetchExchange } from '../api/exchangeApi'
import { formatNumber } from '../utils/functions'

const Exchange = () => {

    const [exc, setExc] = useState({})

    const loadExchange = async () => {
        const { data } = await fetchExchange()
        setExc(data)
    }

    useEffect(() => {
        loadExchange()
    }, [])

    return (
        <div className='flex justify-end text-xs gap-x-1'>
            <p>
                USD/TRY : {formatNumber(exc.dollar?.selling / 1)}
            </p>
            -
            <p>
                USD/EUR : {formatNumber(exc.dollar?.selling / exc.euro?.selling)}
            </p>

        </div>
    )
}

export default Exchange